import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { Metric } from "../../../../metric";
import Image from "./assets/error.svg";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var StatusScreen = function StatusScreen(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    events: {
      headerMetric: ['handleViewSearchEmptyStatus']
    },
    mode: "render",
    "data-t-id": "blocks-StatusScreenBlock"
  }, /*#__PURE__*/React.createElement("section", {
    className: cx('error'),
    "data-t-id": "blocks-StatusScreenBlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('error-content')
  }, /*#__PURE__*/React.createElement(Image, null), text && /*#__PURE__*/React.createElement(Text, {
    align: "center",
    className: cx('error-content__text'),
    color: "tertiary",
    size: "xs"
  }, text))));
};